import { AccordionItem } from '@mm/components';
import React from 'react';
import { ReactComponent as BusinessIcon } from 'assets/icons/business-outlined.svg';
import { isNil } from 'lodash';
import { processAttributes } from '../../../../contacts/components/ContactsDetails/ContactDetailsTabs/ChatVariablesTab/ChatVariablesTab';
import { useSelector } from 'react-redux';
import { selectBusinessAttributes } from '@mm/state/selectors/attributeSelectors';
import { ContactVariable } from '@mm/state/interfaces/contacts';
import classNames from 'classnames';

export const BusinessAttributes = ({
  variables,
  className,
  isBusinessContact,
}: {
  variables: ContactVariable[];
  className?: string;
  isBusinessContact?: boolean;
}) => {
  const businessAttributes = useSelector(selectBusinessAttributes);
  const businessVariables = variables.filter(({ variable }) =>
    businessAttributes.find(attr => attr.id === variable.id),
  );

  if (!isBusinessContact) {
    return null;
  }

  return (
    <div className={className}>
      <AccordionItem
        icon={<BusinessIcon className="contact-details__header-icon" />}
        title="Business Attributes"
        count={businessVariables.length}
        openOnMount
        closeOnOutsideClick={false}
        className="contact-details__accordion-item"
        headingClassName="contact-details__accordion-item-heading"
        arrowClassName="contact-details__caret-arrow"
        caretStyleIcon
      >
        <div
          className={classNames(
            'contact-attributes__attributes',
            'contact-attributes__main-content',
          )}
        >
          {businessVariables.map((variable, idx) => {
            const { name } = variable.variable;

            const redactedVarName = `${name
              .replace(/^VOY_/, '')
              .replaceAll(/_/g, ' ')
              .toLowerCase()}`;

            return (
              !isNil(variable.value) && (
                <div
                  key={`${variable.id}-${idx}`}
                  className="contact-attributes__attribute-row"
                >
                  <div className="contact-attributes__attribute-name">
                    {redactedVarName}
                  </div>
                  <div className="contact-attributes__attribute-value-container">
                    <div className="contact-attributes__attribute-value">
                      {processAttributes(
                        variable.value,
                        variable.variable.name,
                      )}
                    </div>
                  </div>
                </div>
              )
            );
          })}
        </div>
      </AccordionItem>
    </div>
  );
};
